// components/ProjectSelector.jsx

import React from 'react';

const ProjectSelector = ({ 
  projects, 
  selectedProject, 
  onProjectSelect, 
  isLoading, 
  error 
}) => {
  const spinnerStyle = {
    width: '32px',
    height: '32px',
    border: '4px solid #e5e7eb',
    borderTopColor: '#3b82f6',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 16px'
  };

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '32px 0' }}>
        <div style={{ color: '#dc2626', marginBottom: '16px' }}>
          <svg width="48" height="48" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ margin: '0 auto 8px' }}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p style={{ fontSize: '14px' }}>Failed to load projects</p>
          <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>{error}</p>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '32px 0' }}>
        <div style={spinnerStyle}></div>
        <p style={{ color: '#6b7280' }}>Loading projects...</p>
      </div>
    );
  }

  return (
    <div>
      <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '16px' }}>
        Select Project to Copy From
      </h3>
      <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '24px' }}>
        Choose a project to copy basic configuration from. This will help you get started quickly with your new project.
      </p>

      {projects.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '32px 0', color: '#6b7280' }}>
          <p>No projects available to copy from.</p>
        </div>
      ) : (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          maxHeight: '320px',
          overflowY: 'auto'
        }}>
          {projects.map((project) => (
            <div
              key={project.project_id}
              onClick={() => onProjectSelect(project.project_id)}
              style={{
                padding: '16px',
                border: `1px solid ${selectedProject === project.project_id ? '#3b82f6' : '#e5e7eb'}`,
                borderRadius: '8px',
                cursor: 'pointer',
                backgroundColor: selectedProject === project.project_id ? '#eff6ff' : 'white',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (selectedProject !== project.project_id) {
                  e.target.style.backgroundColor = '#f3f4f6';
                  e.target.style.borderColor = '#d1d5db';
                }
              }}
              onMouseLeave={(e) => {
                if (selectedProject !== project.project_id) {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.borderColor = '#e5e7eb';
                }
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <h4 style={{ fontWeight: 'bold', color: '#111827', marginBottom: '4px' }}>
                    {project.project_id}
                  </h4>
                  {project.project_description && (
                    <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>
                      {project.project_description}
                    </p>
                  )}
                </div>
                <div>
                  <svg 
                    width="20" 
                    height="20" 
                    fill="none" 
                    stroke="#9ca3af" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectSelector;